import React__default from 'react';
import styled from 'styled-components';
import { HappyWebSystemError } from '../base/SystemComponent.js';
import { CSSGenerateResponsive } from '../styles/cssGenerate.js';
import { CSSGridGenerateCompatibleColumn } from '../styles/cssGridGenerate.js';

const getColumnSpan = (col, span)=>{
    const columnSpans = [
        null,
        null,
        null
    ];
    // Mobile responsive setter
    if (Array.isArray(col) && col?.length >= 1) {
        columnSpans[0] = {
            startCol: !Array.isArray(col) ? col : col?.[0],
            spanCols: !Array.isArray(span) ? span : span?.[0]
        };
    }
    // Tablet responsive setter
    if (Array.isArray(col) && col?.length >= 2) {
        columnSpans[1] = {
            startCol: !Array.isArray(col) ? col : col?.[1],
            spanCols: !Array.isArray(span) ? span : span?.[1]
        };
    }
    // Desktop responsive setter
    if (!Array.isArray(col) || col.length === 3) {
        columnSpans[2] = {
            startCol: !Array.isArray(col) ? col : col?.[2],
            spanCols: !Array.isArray(span) ? span : span?.[2]
        };
    }
    return columnSpans;
};
/**
 * Styled Components
 */ const ColumnWrapper = styled.div`
  display: flex;
  min-height: 0;
  /* "Columns" will lay out its children as though each column has a span of 1.
  /* && is used to force a higher specitivity for ColumnWrapper's generated CSS so that startCol is respected. */
  &&[data-hpy-web-column] {
    /* manually set ie11-compatible grid props */
    /* styled-components doesn't currently accept grid autoprefixer at runtime (which can provide these fixes) */
    ${(props)=>CSSGenerateResponsive(props.columnSpan)(CSSGridGenerateCompatibleColumn)}
  }
`;
/**
 * Layout component for creating an individual horizontal layout column.
 * Used as compositional component within `Columns` layout.
 *
 * @param span - ResponsiveProp object specifying start column and span col count (e.g. {startCol: 2, spanCols: 3}
 * starts at column 2 and spans 3 columns). If `span` is set on a Column, subsequent Column elements should also
 * set `span` to avoid unexpected layout behaviour (especially in IE11).
 *
 * @example
 * // simple usage
 * <Columns>
 *  <Column />
 *  <Column />
 *  <Column />
 * </Columns>
 *
 * // custom usage
 * <Columns cols={5}>
 *  <Column col={1} span={1}/>
 *  <Column col={2} span={1} />
 *  <Column col={[4,4]} span={[3,2]} />
 * </Columns>
 */ const Column = ({ col , span , children , ...props })=>{
    // Ensure col and span are in sync
    if (Array.isArray(col) && !Array.isArray(span) || Array.isArray(col) && Array.isArray(span) && col.length !== span.length) {
        throw new HappyWebSystemError(Column, "col prop must match ResponsiveProps for span");
    }
    const columnSpan = getColumnSpan(col, span);
    return React__default.createElement(ColumnWrapper, {
        "data-hpy-web-column": true,
        ...props,
        columnSpan: columnSpan
    }, children);
};
Column.dataId = "data-hpy-web-column";
Column.displayName = "Column";

export { Column, getColumnSpan };
